module.exports = __webpack_public_path__ + "img/L_318_324.caaf6d05.png";